<template>
  <div class="styleguide u-wrapper-panel u-overflow-y-scroll u-invisible-scroll">
    <div class="u-row u-pad-sm t-h1 u-bg-grey u-green-dark">
      COLORS
    </div>
    <div class="u-row u-full-width">
      <div class="u-w3of12 u-box-1by1 u-bg-white">
        <div class="t-text u-wrapper-panel u-black u-pad-sm">
          White
        </div>
      </div>
      <div class="u-w3of12 u-box-1by1 u-bg-black">
        <div class="t-text u-wrapper-panel u-black u-pad-sm">
          Black
        </div>
      </div>
      <div class="u-w3of12 u-box-1by1 u-bg-grey">
        <div class="t-text u-wrapper-panel u-black u-pad-sm">
          Grey
        </div>
      </div>
      <div class="u-w3of12 u-box-1by1 u-bg-green">
        <div class="t-text u-wrapper-panel u-black u-pad-sm">
          Green
        </div>
      </div>
      <div class="u-w3of12 u-box-1by1 u-bg-green-dark">
        <div class="t-text u-wrapper-panel u-black u-pad-sm">
          Green-dark
        </div>
      </div>
      <div class="u-w3of12 u-box-1by1 u-bg-red">
        <div class="t-text u-wrapper-panel u-black u-pad-sm">
          Red
        </div>
      </div>
      <div class="u-w3of12 u-box-1by1 u-bg-transparent">
        <div class="t-text u-wrapper-panel u-black u-pad-sm">
          Transparent
        </div>
      </div>
    </div>
    <div class="u-row u-pad-sm t-h1 u-bg-grey u-green-dark">
      TYPOGRAPHY
    </div>
    <div class="u-bg-green u-black">
      <div class="t-h1 u-pad-sm">
        t-h1
      </div>
      <div class="t-h2 u-pad-sm">
        t-h2
      </div>
      <div class="t-h3 u-pad-sm">
        t-h3
      </div>
      <div class="t-h4 u-pad-sm">
        t-h4
      </div>
      <div class="t-text u-pad-sm">
        t-text
      </div>
      <div class="t-text--dacia u-pad-sm">
        t-text--dacia
      </div>
      <div class="t-cta u-pad-sm">
        t-cta
      </div>
      <div class="t-cta__small u-pad-sm">
        t-cta__small
      </div>
      <div class="t-link u-marg-sm u-uppercase">
        t-link
      </div>
    </div>
    <div class="u-row u-pad-sm t-h1 u-bg-grey u-green-dark">
      BUTTONS
    </div>
    <div class="u-row u-top u-pad-sm u-bg-green u-red">
      <app-button class="u-marg-r-sm">
        App Button
      </app-button>
      <app-button :white="true" class="u-marg-r-sm">
        App Button White
      </app-button>
      <app-button :green="true" class="u-marg-r-sm">
        App Button Green
      </app-button>
      <app-button :small="true" class="u-marg-r-sm">
        App Button
      </app-button>
      <app-button :small="true" :white="true" class="u-marg-r-sm">
        App Button White
      </app-button>
      <app-button :small="true" :green="true" class="u-marg-r-sm">
        App Button Green
      </app-button>
    </div>
    <div class="u-row u-pad-sm t-h1 u-bg-grey u-green-dark">
      BUTTONS ROUND
    </div>
    <div class="u-row u-middle u-pad-sm u-bg-green u-red">
      <app-button-round svg="hand" class="u-marg-r-sm" />
      <app-button-round svg="hand" :white="true" class="u-marg-r-sm" />
    </div>
    <div class="u-row u-pad-sm t-h1 u-bg-grey u-green-dark">
      APP ANSWER
    </div>
    <div class="u-row u-top u-pad-sm u-bg-green u-red">
      <app-answer class="u-marg-r-sm" label="App Answer" />
      <app-answer class="u-marg-r-sm" :isSelected="true" label="App Answer" />
      <app-answer class="u-marg-r-sm" :isTrue="true" :isSelected="true" label="App Answer" />
      <app-answer class="u-marg-r-sm" :isSelecting="true" label="App Answer" />
    </div>
    <div class="u-row u-pad-sm t-h1 u-bg-grey u-green-dark">
      ICONS
    </div>
    <div class="u-row u-pad-sm u-bg-green u-red">
      <div class="u-w1of12 u-box-1by1">
        <div class="u-wrapper-panel u-pad-sm">
          <svg class="u-fill-black u-full-height u-full-width u-fit-contain" preserveAspectRatio="xMidYMid meet">
            <use xlink:href="#dacia"/>
          </svg>
        </div>
      </div>
      <div class="u-w1of12 u-box-1by1">
        <div class="u-wrapper-panel u-pad-sm">
          <svg class="u-fill-black u-full-height u-full-width u-fit-contain" preserveAspectRatio="xMidYMid meet">
            <use xlink:href="#menu"/>
          </svg>
        </div>
      </div>
      <div class="u-w1of12 u-box-1by1">
        <div class="u-wrapper-panel u-pad-sm">
          <svg class="u-fill-black u-full-height u-full-width u-fit-contain" preserveAspectRatio="xMidYMid meet">
            <use xlink:href="#close"/>
          </svg>
        </div>
      </div>
      <div class="u-w1of12 u-box-1by1">
        <div class="u-wrapper-panel u-pad-sm">
          <svg class="u-fill-black u-full-height u-full-width u-fit-contain" preserveAspectRatio="xMidYMid meet">
            <use xlink:href="#arrow-down"/>
          </svg>
        </div>
      </div>
      <div class="u-w1of12 u-box-1by1">
        <div class="u-wrapper-panel u-pad-sm">
          <svg class="u-fill-black u-full-height u-full-width u-fit-contain" preserveAspectRatio="xMidYMid meet">
            <use xlink:href="#arrow-right"/>
          </svg>
        </div>
      </div>
      <div class="u-w1of12 u-box-1by1">
        <div class="u-wrapper-panel u-pad-sm">
          <svg class="u-fill-black u-full-height u-full-width u-fit-contain" preserveAspectRatio="xMidYMid meet">
            <use xlink:href="#i"/>
          </svg>
        </div>
      </div>
      <div class="u-w1of12 u-box-1by1">
        <div class="u-wrapper-panel u-pad-sm">
          <svg class="u-fill-black u-full-height u-full-width u-fit-contain" preserveAspectRatio="xMidYMid meet">
            <use xlink:href="#?"/>
          </svg>
        </div>
      </div>
    </div>
    <div @click="isTuto = true" class="u-cursor-pointer u-row u-pad-sm t-h1 u-bg-grey u-green-dark">
      POPIN TUTO
    </div>
    <transition name="t-fader">
      <popin-tuto v-if="isTuto" @close="isTuto = false" :svg="hand" text="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam" cta="J’ai compris 🌞" />
    </transition>
  </div>
</template>

<script>
import AppButton from '@/components/common/AppButton'
import AppButtonRound from '@/components/common/AppButtonRound'
import PopinTuto from '@/components/PopinTuto'
import AppAnswer from '@/components/common/AppAnswer'

export default {
  components: {
    AppButton,
    AppButtonRound,
    PopinTuto,
    AppAnswer
  },

  data () {
    return {
      isTuto: false
    }
  }
}
</script>
